import { create } from 'zustand';
import { VerifiedTransfer } from './use-transfers-store';

export interface ModalStore {
  verifiedTransfer: VerifiedTransfer | undefined;
  setVerifiedTransfer: (transfer: VerifiedTransfer) => void;
  isGuideModalOpen: boolean;
  handleGuideModalOpen: (isOpen: boolean) => void;
  isSwitchModalOpen: boolean;
  handleSwitchModalOpen: (isOpen: boolean) => void;
  isWithdrawConfirmationModalOpen: boolean;
  handleWithdrawConfirmationModalOpen: (isOpen: boolean) => void;
  isQrCodeModalOpen: boolean;
  handleQrCodeModalOpen: (isOpen: boolean) => void;
  qrCodeUrl: string;
  setQrCodeUrl: (qrCodeUrl: string) => void;
  handledVerifiedTransferID: string | undefined;
  setHandledVerifiedTransferID: (id: string) => void;
}

export const useModalStore = create<ModalStore>((set, get) => ({
  verifiedTransfer: undefined,
  setVerifiedTransfer: (transfer) => set({ verifiedTransfer: transfer }),
  handledVerifiedTransferID: undefined,
  setHandledVerifiedTransferID: (id) => set({ handledVerifiedTransferID: id }),
  isGuideModalOpen: false,
  handleGuideModalOpen: (isOpen) => {
    set({
      isGuideModalOpen: isOpen,
    });
  },
  isSwitchModalOpen: false,
  handleSwitchModalOpen: (isOpen) => {
    set({
      isSwitchModalOpen: isOpen,
    });
  },
  isWithdrawConfirmationModalOpen: false,
  handleWithdrawConfirmationModalOpen: (isOpen) => {
    set({
      isWithdrawConfirmationModalOpen: isOpen,
    });
  },
  isQrCodeModalOpen: false,
  handleQrCodeModalOpen: (isOpen) => {
    set({
      isQrCodeModalOpen: isOpen,
    });
  },
  qrCodeUrl: '',
  setQrCodeUrl: (qrCodeUrl: string) => set({ qrCodeUrl }),
}));
